import { Component, OnDestroy, OnInit } from '@angular/core';
import { GlobalMessageService, OCC_USER_ID_ANONYMOUS, Product, UserIdService } from '@spartacus/core';
import {
  PageLayoutService,
  ProductListComponent,
  ProductListComponentService,
  ViewConfig,
  ViewModes,
} from '@spartacus/storefront';
import { FacetSortService } from './product-facet-navigation/facet-sort.service';
import { DEVICE_SIZE } from '../../../../core/models/others.model';
import { BehaviorSubject, combineLatest, distinctUntilKeyChanged, of, Subscription, take } from 'rxjs';
import { ProductAuxService } from '../_core/product-aux.service';
import { ProductsPricesRequest } from '../../../../core/models/product.model';
import { failStatus, initialStatus, successStatus } from '../../../../core/models/request-status.model';
import { ToasterService } from '../../../../components/toaster/toaster.service';
import { ListViewModeService } from './list-view-mode/list-view-mode.service';

@Component({
  selector: 'cx-product-list',
  templateUrl: './product-list.component.html',
  styleUrl: './product-list.component.scss',
  standalone: false,
})
export class CustomProductListComponent extends ProductListComponent implements OnInit, OnDestroy {
  DEVICE_SIZE = DEVICE_SIZE;

  products$ = new BehaviorSubject<Product[]>([]);
  thirdPartyPriceRequest$ = new BehaviorSubject<ProductsPricesRequest>(initialStatus);
  currentViewMode$ = of(ViewModes.List); // this.facetSortService.currentViewMode$;
  _subscription = new Subscription();
  compactMode$ = this.listViewModeService.getStatus();

  constructor(
    private _pageLayoutService: PageLayoutService,
    private _productListComponentService: ProductListComponentService,
    private _globalMessageService: GlobalMessageService,
    private facetSortService: FacetSortService,
    public _scrollConfig: ViewConfig,
    public productAuxService: ProductAuxService,
    public toasterService: ToasterService,
    private userIdService: UserIdService,
    private listViewModeService: ListViewModeService,
  ) {
    super(_pageLayoutService, _productListComponentService, _globalMessageService, _scrollConfig);
  }

  override ngOnInit() {
    super.ngOnInit();
    this.getProductsPrices();
  }

  override ngOnDestroy() {
    super.ngOnDestroy();
    this._subscription.unsubscribe();
  }

  getProductsPrices() {
    this._subscription.add(
      combineLatest([this.model$.pipe(distinctUntilKeyChanged('products')), this.userIdService.getUserId()]).subscribe(
        ([model, userId]) => {
          this.products$.next(
            model.products?.map(product => ({
              ...product,
              thirdPartyPriceStatus: initialStatus,
              yourPrice: undefined as undefined,
              differencePrice: undefined as undefined,
            })) || [],
          );

          if (userId !== OCC_USER_ID_ANONYMOUS) {
            const productsIDS = (model.products || [])
              .map(product => product.code as string)
              .filter(code => code !== undefined);

            this.productAuxService
              .getProductsPrices({ productsIDS })
              .pipe(take(1))
              .subscribe(request => {
                this.thirdPartyPriceRequest$.next(request);
                const products = this.products$.getValue();
                const productWithPrices = products.map(product => this.mergeThirdPartyProductPrice(product));
                this.products$.next(productWithPrices);
              });
          }
        },
      ),
    );
  }

  mergeThirdPartyProductPrice(product: Product): Product {
    const productPrices = this.thirdPartyPriceRequest$.getValue()?.products || [];
    const thirdPartyPrice = productPrices.find(productPrice => productPrice.productCode === product.code);

    if (thirdPartyPrice) {
      return {
        ...product,
        yourPrice: thirdPartyPrice.yourPrice,
        differencePrice: thirdPartyPrice.difference,
        thirdPartyPriceStatus: successStatus,
      };
    }

    return {
      ...product,
      thirdPartyPriceStatus: failStatus,
    };
  }
}
